module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "card elevation-7",
    attrs: {
      "fixed": ""
    }
  }, [_c('div', [_vm._v("\n  © 2017 BlueCodersMeet | Made with "), _c('v-spacer'), _vm._v(" "), _c('icon', {
    staticClass: "red--text",
    attrs: {
      "name": "heart",
      "scale": "1"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Vue.js'
      }),
      expression: "{ html: 'Vue.js' }",
      arg: "top"
    }],
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.vuejs,
      "height": "14"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Vuetify.js'
      }),
      expression: "{ html: 'Vuetify.js' }",
      arg: "top"
    }],
    attrs: {
      "href": "https://vuetifyjs.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.icons.vuetify,
      "height": "15"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Hosted on github.io'
      }),
      expression: "{ html: 'Hosted on github.io' }",
      arg: "top"
    }],
    attrs: {
      "href": "https://github.io",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "github-alt",
      "scale": "1"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: ({
        html: 'Click to view source on GitHub'
      }),
      expression: "{ html: 'Click to view source on GitHub' }",
      arg: "top"
    }],
    attrs: {
      "href": "https://github.com/BlueCodersDev/BlueCodersDev.github.io",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "code",
      "scale": "1"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd8c5fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottombar.vue
// module id = 828
// module chunks = 1